export default __webpack_public_path__ + "static/media/step3_jack.f467c3d4.png";